import { methods, ServiceMaker } from './index';

const { POST ,GET,PUT} = methods;

export const updateuserid = data => ServiceMaker(`v1/api/customer/updateusername`, POST, null, data);
export const canceluser = (serialNo,number) => 
ServiceMaker(`v1/api/customer/user-profile?serialNo=${serialNo}&mobile=${number} `, GET, null, data);

export const getusercancel = (payload) => ServiceMaker(`/v1/api/customer/user-profile?${payload.serialNo}=${payload.number}&${payload.mobile}=${payload.anumber}`, GET, null);
export const CancelRegistration = (payload) => ServiceMaker(`/v1/api/customer/cancelregistration`, PUT, null, payload);


